<template>
    <div class="wrapper">
      <div class="topo-header centro">
        <botao-voltar nomeRota="Servidor" />
        <h1>{{ servidorForm.id ? "Editar" : "Novo(a)" }} Servidor(a)</h1>
      </div>
      <div class="tab-dados-basicos">
        <div class="form centro">
          <MsgErroFormularios
            v-if="erro && msgErros"
            :mensagens="msgErros"
            :erro="erro"
            @fechar-erro="fecharErro"
          />
          <p>Os campos com asterisco (*) são de preenchimento obrigatório.</p>
          <form @submit.prevent="enviarForm">
            <div class="caixa-form item">
              <div class="flexbox-1">
                <div class="item">
                  <label
                    ><b>{{ possuiAsterisco("CPF:") }}</b></label
                  >
                  <the-mask
                    :mask="['###.###.###-##']"
                    placeholder="Digite o CPF"
                    v-model="servidorForm.cpf"
                    :disabled="servidorForm.id || carregando"
                  />
                </div>
                <div class="item">
                  <button
                    class="btn-carregar-dados"
                    @click.prevent="buscarDados(servidorForm.cpf)"
                    :disabled="servidorForm.id || carregando"
                  >
                    <img
                      v-if="carregando"
                      class="spinner-loading"
                      src="../../assets/imagens/loadingSpinner.gif"
                      alt="Spinner de carregamento"
                    />
                    <p>{{ carregando ? 'Carregando...' : 'Carregar Dados' }}</p>
                  </button>
                </div>
                <div class="item">
                  <label
                    ><b>{{ possuiAsterisco("Nome:") }}</b></label
                  >
                  <input
                    type="text"
                    placeholder="O nome será preenchido automaticamente."
                    v-model="servidorForm.nome"
                    readonly
                    class="campo-somente-leitura"
                  />
                </div>
              </div>
              <div class="item">
                <div id="divLotacoes">
                  <div class="item multiselect">
                    <MultiplasLotacoes v-model="lotacoesFormLocal" @validation-error="handleLotacaoError" @clear-validation-error="clearLotacaoError"></MultiplasLotacoes>
                  </div>
                </div>
              </div>
              <div class="bt-salvar">
              <button id="botao-salvar" title="Criar/Atualizar" type="submit">
                <img
                  id="spinner-loading"
                  class="spinner-loading"
                  src="../../assets/imagens/loadingSpinner.gif"
                  alt="Spinner de carregamento"
                />
                <p id="conteudo-botao">
                  {{ servidorForm.id ? "Atualizar" : "Criar" }}
                </p>
              </button>
            </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </template>

  <script lang="js">
  import ServidorApi from "../../services/ServidorApi";
  import LotacaoServidorApi from "../../services/LotacaoServidorApi";
  import BotaoVoltar from "../../components/BotaoVoltar.vue";
  import MsgErroFormularios from "../MsgErroFormularios";
  import MultiplasLotacoes from '../../components/servidores/MultiplasLotacoes.vue';
  import { TheMask } from "vue-the-mask";

  export default {
      name: "ServidorForm",
      props: {
          servidor: {
              type: Object,
              required: false,
          },
          lotacoesServidorForm: {
              type: Array,
              required: false,
          },
          lotacoesOriginais: {
              type: Array,
              required: false,
          },
      },
      components: {
          BotaoVoltar,
          MsgErroFormularios,
          MultiplasLotacoes,
          TheMask
      },
      data() {
          return {
              nomeRotaAtual: this.$router.currentRoute.name,
              carregando: false,
              erro: false,
              msgErros: {
                  cpf: '',
                  nome: '',
                  unidades: '',
                  default: '',
              },
              lotacoesFormLocal: this.lotacoesServidorForm ? [...this.lotacoesServidorForm] : [],
              servidorForm: this.servidor
                ? {
                    id: this.servidor.id,
                    cpf: this.servidor.cpf,
                    nome: this.servidor.nome,
                }
                : {
                    id: null,
                    cpf: null,
                    nome: null,
                },
          };
      },
      
      created() {
          this.servidorApi = new ServidorApi();
          this.lotacaoServidorApi = new LotacaoServidorApi();
      },
      mounted() {
      },
      watch: {
        lotacoesServidorForm: {
          handler(novasLotacoes) {
            this.lotacoesFormLocal = [...novasLotacoes];
          },
          deep: true,
        },
      },
      methods: {
          fecharErro() {
              this.erro = false;
          },
          async buscarDados(cpf) {
              if (!cpf) {
                  this.erro = true;
                  this.msgErros.cpf = "CPF não preenchido.";
                  return;
              }
              this.carregando = true;
              this.erro = false;
              try {
                  const rhNet = await this.servidorApi.getDadosRhNet(cpf);
                  this.servidorForm.nome = rhNet.nome;
              } catch (err) {
                  console.error(err);
                  this.erro = true;
                  const { response } = err;
                  if (response && response.data) {
                      this.msgErros.default = response.data.mensagem;
                  } else {
                      this.msgErros.default =
                          "Houve um erro ao buscar os dados do servidor.";
                  }
              } finally {
                  this.carregando = false;
              }
          },
          async enviarForm() {
            let conteudoBotao = document.getElementById("conteudo-botao");
            const textoConteudoBotao = conteudoBotao?.innerHTML || "";

            let flag = this.validarForm(this.servidorForm, this.lotacoesFormLocal);

            if (flag === 1 || flag === true) {
                this.erro = true;
                window.scrollTo({ top: 0, behavior: 'smooth' });
                return false;
            }

            try {
                this.carregando = true;
                this.erro = false;
                this.msgErros = '';

                this.mudarBotaoSalvar(textoConteudoBotao);

                // Cancela requisição anterior (se existir)
                this.servidorApi.cancelTokens?.setServidor?.cancel();

                let attributes = this.lotacoesFormLocal.map(lotacao => ({
                    id: lotacao.id,
                    id_unidade: lotacao.unidade ? lotacao.unidade.id : null,
                    id_unidade_superior: lotacao.unidadeSuperior ? lotacao.unidadeSuperior.id : null,
                    data_inicio: lotacao.dataInicio,
                    data_final: lotacao.dataFim,
                    representante: lotacao.representante,
                    _destroy: false // Marca as que estão na tela para NÃO serem destruídas
                }));


                if (this.nomeRotaAtual !== "ServidorNew" && this.lotacoesOriginais) {
                    const removidas = this.lotacoesOriginais.filter(original => 
                        !this.lotacoesFormLocal.some(atual => atual.id === original.id)
                    );

                    // Adiciona as removidas no pacote mas com a flag _destroy: true
                    removidas.forEach(removida => {
                        attributes.push({
                            id: removida.id,
                            _destroy: true 
                        });
                    });
                }

                const payload = {
                    ...this.servidorForm,
                    lotacao_servidores_attributes: attributes
                };

                let dataServidor;

                dataServidor = await this.servidorApi.setServidor(payload);

                setTimeout(() => {
                    this.$router.push({
                        name: "ServidorShow",
                        params: { id: dataServidor.id },
                    });
                }, 1000);

            } catch (err) {
                if (this.servidorApi.isCancel(err)) {
                    this.carregando = false;
                    this.mudarBotaoSalvar(textoConteudoBotao);
                    return;
                }

                console.error(err);
                this.carregando = false;
                this.erro = true;
                this.mudarBotaoSalvar(textoConteudoBotao);

                const { response } = err;
                if (response?.data) {
                    this.msgErros = response.data.errors || response.data;
                } else {
                    this.msgErros = "Houve um erro ao salvar o registro. Por favor, tente novamente.";
                }
            }
        },

          validarForm(servidorForm,lotacoes) {
              let hasError = false;
              this.msgErros = { cpf: "", nome: "", unidades: "", default: "" };

              if (!servidorForm.cpf) {
                  this.msgErros.cpf = "O campo CPF não foi preenchido.";
                  hasError = true;
              } else if (!this.validarCPF(servidorForm.cpf)) {
                  this.msgErros.cpf = "CPF inválido.";
                  hasError = true;
              }

              if (!servidorForm.nome) {
                  this.msgErros.nome = "O campo nome não foi preenchido.";
                  hasError = true;
              }

              if (lotacoes.length === 0) {
                this.msgErros.unidades = "Nenhuma lotação adicionada ao servidor.";
                hasError = true;
              } else {
                let errosUnidades = [];
                lotacoes.forEach((u, index) => {
                  if (!u.unidade) {
                    errosUnidades.push(`Lotação ${index + 1}: O campo unidade não foi preenchido.`);
                  }
                  if (!u.dataInicio) {
                    errosUnidades.push(`Lotação ${index + 1}: O campo data de início não foi preenchido.`);
                  }
                  // O Gabinete do Secretário (GAB) é a unidade máxima: não possui unidade superior.
                  const ehGabinete = u.unidade && u.unidade.sigla === 'GAB';
                  if (u.representante && !u.unidadeSuperior && !ehGabinete) {
                    errosUnidades.push(`Lotação ${index + 1}: Unidade superior é obrigatória quando o servidor é representante.`);
                  }
                });
                if(errosUnidades.length > 0){
                  this.msgErros.unidades = errosUnidades.join(' ');
                  hasError = true;
                }
              }

              return hasError;
          },
          validarCPF(cpf) {
              cpf = cpf.replace(/\D/g, '');
              if (cpf.length !== 11 || !!cpf.match(/(\d)\1{10}/)) {
                  return false;
              }

              let soma = 0;
              let resto;

              for (let i = 1; i <= 9; i++) {
                  soma += parseInt(cpf.charAt(i - 1)) * (11 - i);
              }
              resto = (soma * 10) % 11;

              if (resto === 10 || resto === 11) resto = 0;
              if (resto !== parseInt(cpf.charAt(9))) {
                  return false;
              }

              soma = 0;
              for (let i = 1; i <= 10; i++) {
                  soma += parseInt(cpf.charAt(i - 1)) * (12 - i);
              }
              resto = (soma * 10) % 11;

              if (resto === 10 || resto === 11) resto = 0;
              if (resto !== parseInt(cpf.charAt(10))) {
                  return false;
              }

              return true;
          },
          possuiAsterisco(texto) {
              return `* ${texto}`;
          },
          mudarBotaoSalvar(textoBotao) {
            let botaoSalvar = document.getElementById("botao-salvar");
            let conteudoBotao = document.getElementById("conteudo-botao");
            let spinnerLoading = document.getElementById("spinner-loading");

            let novoTextoConteudoBotao = "Carregando"

            //mudar para o carregando
            botaoSalvar.disabled = true;
            botaoSalvar.style.backgroundColor = "gray"
            conteudoBotao.innerHTML = novoTextoConteudoBotao;
            conteudoBotao.style.display = "inline-block"
            spinnerLoading.style.visibility = "visible"
            spinnerLoading.style.position = "relative"

            if (this.erro == true) {
                //mudar para o padrão (da aba dados básicos)
                botaoSalvar.disabled = false;
                botaoSalvar.style.backgroundColor = "#005516"
                conteudoBotao.innerHTML = textoBotao;
                spinnerLoading.style.visibility = "hidden"
                spinnerLoading.style.position = "absolute"
            }
        },
        handleLotacaoError(message) {
          this.msgErros.unidades = message;
          this.erro = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        clearLotacaoError() {
          if (this.msgErros && this.msgErros.unidades) {
            this.msgErros.unidades = "";
            if (Object.values(this.msgErros).every(msg => !msg)) {
              this.erro = false;
            }
          }
        },
      },

  };
  </script>

<style lang="scss">
div#divLotacoes {
  place-self: center;
  width: 100%;
}
.campo-somente-leitura {
  background-color: #c4bcbc; /* Um cinza bem claro apenas para diferenciar */
  cursor: not-allowed;      /* Muda o cursor para indicar que não digita */
}
.spinner-loading {
  visibility: visible;
  position: relative;
  height: 1rem;
  display: inline-block;
}

@media screen and (min-width: "1066px") {
  .caixa-form {
    .flexbox-1 {
      display: grid;
      grid-template-columns: 1fr 0.5fr 2fr;
      gap: 2rem;
    }

    .flexbox-2 {
      display: flex;
      justify-content: space-between;
      gap: 2rem;
    }

    .flexbox-3 {
      display: grid;
      grid-template: "a b c";
      grid-template-columns: 1.5fr 3fr 1.5fr;
      gap: 1.5rem;
    }
  }
}
</style>